import { createContext } from 'react';
import HoursManagementContextPropsType from './HoursManagementContextPropTypes';
import config from './config';

export default createContext<HoursManagementContextPropsType>(config);
